import RoutingComponent from "../../../base/common/RoutingComponent";
import formateTaskInfoData from "../../sections/taskInfoSections/formateTaskInfoData";
import formateProcedureInfoData from "../../sections/procedureInfoSections/formateProcedureInfoData";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import {
  procedureJbStatus,
  procedureStatusValues,
  processDefaultTableSortFile,
} from "../../publicDictionaryValues";
import { disableInteraction, enableInteraction } from "utils";

export default class ProcessBase extends RoutingComponent {
  constructor(props: any) {
    super(props);
    // @ts-ignore
    this.user = this.appSetting.localStorageValue.user.get();
    // @ts-ignore
    this.supportingFileNum = 0;
    // @ts-ignore
    this.flowCategoryID = null;
    // @ts-ignore
    this.workflowProcessInstanceId = null;
    // @ts-ignore
    this.isRevisePage = false;
    // @ts-ignore
    this.isApprovePage = true;
    // @ts-ignore
    this.tiggerTimes = 0;
    // @ts-ignore
    this.taskID = this._getRoutingParam("ProcedureTaskId");
    // @ts-ignore
    this.procedureID = this._getRoutingParam("ProcedureID");
    // @ts-ignore
    this.procedureStepID = this._getRoutingParam("ProcedureStepID");
    // @ts-ignore
    this.actionID = null;
    // @ts-ignore
    this.initProcedureTableData = [];
    // @ts-ignore
    this.initSupportingTableData = [];
    // @ts-ignore
    this.procedureTableData = [];
    // @ts-ignore
    this.supportingTableData = [];
    // @ts-ignore
    this.isApprovePendingPage = undefined;
    // @ts-ignore
    this.isApproveCompletePage = undefined;
    // @ts-ignore
    this.isRevisePendingPage = undefined;
    // @ts-ignore
    this.isReviseCompletePage = undefined;
    // @ts-ignore
    this.isSubmitCompletePage = undefined;
  }

  /**
   * Set Component Global Variables
   */
  setGlobalVariables = () => {
    // @ts-ignore
    this.initSavedInSectionState = {
      savedInReturnReasonValue: null,
      savedInReturnReasonInputValue: null,
      savedInReasonStatus: null,
      procedureSaveInCategoryStatusID: null,
      savedInRadioValue: null,
      isSavedInReturned: false,
      isSavedInApproveBtnDisabled: false,
      isSavedInReturnBtnDisabled: false,
      isSavedInError: false,
    };

    // @ts-ignore
    this.primitiveSavedInSectionState = JSON.parse(JSON.stringify(this.initSavedInSectionState));

    // @ts-ignore
    this.initServerPathSectionState = {
      serverPathValue: null,
      serverPathReturnReasonValue: null,
      serverPathReturnReasonInputValue: null,
      serverPathReasonStatus: null,
      clientServerPathStatusID: null,
      clientServerPathStatusName: null,
      clientServerPath: null,
      isServerPathReturned: false,
      isServerPathApproveBtnDisabled: false,
      isServerPathReturnBtnDisabled: false,
    };

    // @ts-ignore
    this.primitiveServerPathSectionState = JSON.parse(
      JSON.stringify(this.initServerPathSectionState)
    );

    // @ts-ignore
    this.initProcedureFileTableState = {
      returnedList: [],
      fileTableJbStatus: null,
      fileTableReturned: false,
      fileTableReturnReasonValue: null,
      fileTableReasonStatus: null,
      attachment: {},
    };
  };

  /* function about click action buttons to jeep list page */
  closePage = () => {
    // @ts-ignore
    window.location = "/ToDoList";
  };

  getProcedureStatus = (statusId: any) => {
    // @ts-ignore
    return procedureStatusValues[statusId];
  };

  setPageData = (result: any, fn: any) => {
    if (result.procedureID === null || result.procedureID === undefined) {
      return;
    }

    this.setState(
      {
        pageState: {
          ...this.state.pageState,
          requestByID: result.requestByID,
          requestByName: result.requestByName,
          receiveDate: result.reviceDate,
          procedureID: result.procedureID,
          procedureProcessId: result.processID,
          procedureStepID: result.procedureStepID,
          currentRole: result.workflowStepName,
          procedureStepStatus: result.procedureStepStatus,
          rejectReason: result.rejectReason,
          procedureStatus: this.getProcedureStatus(result.procedureStatusID),
          procedureStatusID: result.procedureStatusID,
          flowCategoryID: result.flowCategoryID,
          procedureAccountID: result.taskInfomation?.procedureAccountID,
          procedureNote: result.procedureNote,
          ...((location.pathname.startsWith("/UpdateProcdureFileProcess") ||
            location.pathname.startsWith("/CreateProcdureFileProcess")) && {
            excludedReviewersList: result?.procedureFolder?.excludedReviewersList ?? [],
          }),
        },
      },
      fn
    );
  };

  setTaskInfoData = (result: any) => {
    if (result.taskInfomation === null || result.taskInfomation === undefined) {
      return;
    }

    this.setState({
      taskInfoData: formateTaskInfoData.setTaskInfoData(result),
    });
  };

  setProcedureInfoData = (result: any) => {
    if (result.procedureStatusID === null || result.procedureStatusID === undefined) {
      result.procedureStatusID = this.state.pageState.procedureStatusID;
    }

    if (
      result.procedureNote === null ||
      result.procedureNote === undefined ||
      result.procedureNote === ""
    ) {
      result.procedureNote = this.state.pageState.procedureNote;
    }

    this.setState({
      procedureInfoData: formateProcedureInfoData.setProcedreInfoData(result),
    });
  };

  /* function about adjust data when get data from api */
  handleDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID" || key === "supportingFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  /**
   * set procedure file table data to a constant
   * @param {*} folder
   */
  setProcedureTableData = (folder: any) => {
    if (folder === null) {
      return;
    }
    const procedureFileList = processDefaultTableSortFile(folder.procedureFiles, this._formateDate);
    procedureFileList.forEach((procedureFile) => {
      // @ts-ignore
      const isReviseOrNoOldFile =
        this.handleDataNull(procedureFile, "oldFileID") === null || !this.isRevisePage;
      const approvedDate = this.handleDataNull(procedureFile, "approvedDate");
      if (!procedureFile.isDelete) {
        const lineId = this._generateGUID();
        const uploadedDate = this.handleDataNull(procedureFile, "uploadedDate");
        // @ts-ignore
        this.procedureTableData.push({
          data: [
            { name: "lineId", value: lineId },
            {
              name: "fileId",
              value: isReviseOrNoOldFile
                ? this.handleDataNull(procedureFile, "fileID")
                : this.handleDataNull(procedureFile, "oldFileID"),
            },
            {
              name: "procedureFileID",
              value: this.handleDataNull(procedureFile, "procedureFileID"),
            },
            {
              name: "procedureFileStepID",
              value: this.handleDataNull(procedureFile, "procedureFileStepID"),
            },
            {
              name: "fileKey",
              value: this.handleDataNull(procedureFile, "fileKey"),
            },
            {
              name: "fileName",
              value: isReviseOrNoOldFile
                ? this.handleDataNull(procedureFile, "fileName")
                : this.handleDataNull(procedureFile, "oldFileName"),
            },
            {
              name: "uploadedDate",
              value: this._formateDate(uploadedDate),
            },
            {
              name: "uploadByName",
              value: this.handleDataNull(procedureFile, "uploadByName"),
            },
            {
              name: "uploadById",
              value: this.handleDataNull(procedureFile, "uploadBy"),
            },
            {
              name: "approveDate",
              value: this._formateDate(approvedDate),
            },
            {
              name: "jbProcedure",
              // @ts-ignore
              value: procedureJbStatus[this.handleDataNull(procedureFile, "jbProcedure")],
            },
          ],
          checked: false,
        });
      }
    });
  };

  /**
   * set supporting file table data to a constant
   * @param {*} folder
   */
  setSupportingTableData = (result: any) => {
    if (result.supportingFolder === null) {
      return;
    }
    const supportingFileList = processDefaultTableSortFile(
      result.supportingFolder.supportingFiles,
      this._formateDate
    );
    let isRevise = false;
    if (
      result.workflowProcessStepInfo !== undefined &&
      result.workflowProcessStepInfo !== null &&
      result.workflowProcessStepInfo.annotations.length !== 0
    ) {
      isRevise =
        result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
          .value === "1";
    }
    supportingFileList.forEach((supportingFile) => {
      const isReviseOrNoOldFile =
        this.handleDataNull(supportingFile, "oldFileID") === null || !isRevise;
      if (!supportingFile.isDelete) {
        const lineId = this._generateGUID();
        const uploadedDate = this.handleDataNull(supportingFile, "uploadedDate");
        const approvedDate = this.handleDataNull(supportingFile, "approvedDate");
        // @ts-ignore
        this.supportingTableData.push({
          data: [
            { name: "lineId", value: lineId },
            {
              name: "fileId",
              value: isReviseOrNoOldFile
                ? this.handleDataNull(supportingFile, "fileID")
                : this.handleDataNull(supportingFile, "oldFileID"),
            },
            {
              name: "supportingFileID",
              value: this.handleDataNull(supportingFile, "supportingFileID"),
            },
            {
              name: "supportingFileStepID",
              value: this.handleDataNull(supportingFile, "supportingFileStepID"),
            },
            {
              name: "fileKey",
              value: this.handleDataNull(supportingFile, "fileKey"),
            },
            {
              name: "fileName",
              value: isReviseOrNoOldFile
                ? this.handleDataNull(supportingFile, "fileName")
                : this.handleDataNull(supportingFile, "oldFileName"),
              tagValue: this.handleDataNull(supportingFile, "fileTagID"),
            },
            {
              name: "uploadedDate",
              value: this._formateDate(uploadedDate),
            },
            {
              name: "uploadByName",
              value: this.handleDataNull(supportingFile, "uploadByName"),
            },
            {
              name: "uploadById",
              value: this.handleDataNull(supportingFile, "uploadBy"),
            },
            {
              name: "approveDate",
              value: this._formateDate(approvedDate),
            },
            {
              name: "approveTime",
              value: approvedDate,
            },
          ],
          checked: false,
        });
      }
    });
  };

  /**
   * set procedure file table data to state
   * @param {*} result
   */
  setProcedureFileData = (result: any) => {
    this.setProcedureTableData(result.procedureFolder);
  };

  /**
   * set supporting file table data to state
   * @param {*} result
   */
  setSupportingFileData = (result: any) => {
    this.setSupportingTableData(result);
  };

  setShareTaskData = (result: any) => {
    if (result.shareTask === null || result.shareTask === undefined) {
      return;
    }

    this.setState({
      shareTaskData: result.shareTask,
    });
  };

  setTlReviewData = (result: any) => {
    if (result.tlReview === null || result.tlReview === undefined) {
      return;
    }

    this.setState({
      tlReviewData: result.tlReview,
    });
  };

  setApplyJbData = (result: any) => {
    // this is an empty function
  };

  setInitState = (result: any, isRevise: any, fn: any) => {
    this.setPageData(result, fn);
    this.setTaskInfoData(result);
    this.setProcedureInfoData(result);
    this.setProcedureFileData(result);
    this.setSupportingFileData(result);
    this.setShareTaskData(result);
    this.setTlReviewData(result);
    this.setApplyJbData(result);
  };

  _getProcedureFolderSuccess = (stepItemResult: any, flowDataResult: any) => {
    const result = flowDataResult ? { ...stepItemResult, ...flowDataResult } : stepItemResult;
    if (result.statusCode === 401) {
      console.log(result.message);
    } else {
      let isRevise = false;
      let isApprove = true;

      if (result.workflowProcessStepInfo !== null && result.workflowProcessStepInfo.length !== 0) {
        // @ts-ignore
        this.tiggerTimes = result.sequence;
      }

      if (
        result.workflowProcessStepInfo !== null &&
        result.workflowProcessStepInfo.annotations.length !== 0
      ) {
        isRevise =
          result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
            .value === "1";
        isApprove =
          result.workflowProcessStepInfo.annotations.find((item: any) => item.name === "IsRevise")
            .value === "0";
      }
      if (result.procedureID !== null) {
        // @ts-ignore
        this.flowCategoryID = result.flowCategoryID;
        // @ts-ignore
        this.actionID = result.actionID;
        // @ts-ignore
        this.workflowProcessInstanceId = result.workflowProcessInstanceId;
        this.setInitState(result, isRevise, this._hideLoading);
        // @ts-ignore
        this.isRevisePage = isRevise;
        // @ts-ignore
        this.isApprovePage = isApprove;
        // @ts-ignore
        this.triggerTimes = result.sequence;
      } else {
        console.log(result.message);
        this._hideLoading();
      }
    }
  };

  _getProcedureFolderError = (error: any, msg: any) => {
    console.log(error);
    this._alertError(msg);
    this._hideLoading();
  };

  _getPrimaryProcedureOwnerDDLSuccess = (result: any) => {
    this.setState({
      ppoList: result,
    });
  };

  _getPrimaryProcedureOwnerDDLFailed = () => {
    this._alertError("Get Primary Procedure Owner Failed");
  };

  /* function about show loading */
  _showLoading = () => {
    disableInteraction();
    this.setState({
      pageState: { ...this.state.pageState, loading: true },
    });
  };

  _hideLoading = async () => {
    await enableInteraction();
    this.setState({
      pageState: { ...this.state.pageState, loading: false },
    });
  };

  updateProcedureFileNum = async (num1: any, num2: any) => {
    await new Promise((resolve) => {
      this.setState(
        (prevState: any) => ({
          pageState: {
            ...prevState.pageState,
            loading: true,
            procedureFileNum: num1,
            uploadProcedureFileNum: num2,
          },
        }),
        // @ts-ignore
        resolve
      );
    });
  };

  getInitData = (
    initDataFun: any,
    msg: any,
    interfaceList: any,
    flowDataResult: any,
    mergePayloadMap: any
  ) => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const para = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID?.trim() === "" ? null : this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };
    this._showLoading();

    // @ts-ignore
    const successFunc = flowDataResult
      ? (response: any) => this._getProcedureFolderSuccess(response, flowDataResult)
      : (response: any) => this._getProcedureFolderSuccess(response);

    initDataFun(
      para,
      successFunc,
      (error: any) => this._getProcedureFolderError(error, msg),
      interfaceList,
      mergePayloadMap
    );

    // @ts-ignore
    ProcedureDetailService.getPrimaryProcedureOwnerDDL(
      this.taskID,
      this._getPrimaryProcedureOwnerDDLSuccess,
      this._getPrimaryProcedureOwnerDDLFailed
    );
  };
}
